import * as React from 'react';
import { ProgressIndicator } from 'office-ui-fabric-react/lib/ProgressIndicator';

export const ProgressIndicatorIndeterminateExample: React.FunctionComponent = () => (
  <ProgressIndicator label="Example title" description="Example description" />
);
